import { classNamePrefix as prefixCt } from "@/utils/common";
import "./index.less";

export default class bulletListRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("bullet-list")}`;
    this.config = config;
  }
}
